import { useContext, useEffect } from 'react'
import { ApplicationContext } from '../context/application'
import { useRouter } from 'next/router'
import { useGetApplicationBasicInfoLazyQuery } from '../../types/graphql'

export const useApplicationBasicInfo = function useApplicationBasicInfo() {
    const applicationContext = useContext(ApplicationContext)
    const router = useRouter()
    const [getApplicationBasicInfo, { data, refetch, called }] = useGetApplicationBasicInfoLazyQuery({
        fetchPolicy: 'network-only',
    })

    useEffect(() => {
        const applicationId = router.query.applicationId?.toString() || applicationContext?.application?.id

        if (applicationId) {
            void getApplicationBasicInfo({ variables: { applicationId: applicationId } })
        }
    }, [router])

    useEffect(() => {
        if (data && data.personApplication) {
            applicationContext.setApplication(data.personApplication.applicationDetail)
            applicationContext.setLocation(data.personApplication.locationDetail)
            applicationContext.setCommunication(data.personApplication.communicationSetting)

            applicationContext.setDocuments(
                data.personApplication.documents.edges.filter((item) => !item.node.rejected)
            )
            const profile = {
                ...data.personApplication.profile,
                dob: new Date(data.personApplication.profile.dob),
            }
            applicationContext.setProfile(profile)
        }
    }, [data])

    return {
        refetch,
        called,
    }
}
